<template>

    <div v-if="loading" class="loading-overlay">
      <div class="loading-container">
        <div class="spinner mt-3"></div>
        <div class="loading-text">Seohan</div>
      </div>
    </div>

    <div class="container-fluid py-4 custom-font" style="padding-right: 30px; padding-left: 30px;">
      <!-- ✅ 제목 추가 -->
      <div class="row mt-3">
        <div class="col" v-if="!poNotVisible.includes(username)">
          <h4 class="font-weight-bold text-left section-title">Order Management</h4>
        </div>
      </div>
  
      <!-- ✅ 카드 영역 -->
      <div class="row d-flex justify-content-between flex-wrap"  v-if="!poNotVisible.includes(username)" >
        <v-card
          v-for="(item, index) in cards"
          :key="index"
          class="material-card pa-5 d-flex align-center justify-center"
          >
          <div class="d-flex justify-content-start ml-3 mt-2">
            <v-btn :to="item.route" variant="text" class="text-h6 font-weight-bold text-left" style="padding-left: 0px;">
              <v-icon :icon="item.icon" class="mr-2"></v-icon>
              {{ item.label }}
            </v-btn>
          </div>
        </v-card>
      </div>
      <!-- ✅ Material Management 제목 -->
      <div v-if="materialScanVisible.includes(username)" class="row mt-5">
        <div class="col">
          <h4 class="font-weight-bold text-left section-title">Material Management</h4>
        </div>
      </div>

      <!-- ✅ Material Management 카드 -->
      <div v-if="materialScanVisible.includes(username)" class="row d-flex flex-row">
        <v-card
          v-for="(item, index) in cards2"
          :key="index"
          class="material-card pa-5 d-flex align-center justify-center"
          >
          <div class="d-flex justify-content-start mt-2">
            <v-btn :to="item.route" variant="text" class="text-h6 font-weight-bold text-left btn-align" style="padding-left: 0px;" >
              <v-icon :icon="item.icon" class="mr-2"></v-icon>
              {{ item.label }}
            </v-btn>
          </div>
        </v-card>
      </div>



      <div class="row mt-5">
        <div class="col">
            <h4 class="font-weight-bold text-left section-title">Status</h4>
        </div>
        </div>

        <!-- Bar & Pie Chart 카드 -->
        <div class="row d-flex justify-content-between flex-wrap">
        <!-- Bar Chart 카드 -->
        <v-card class="chart-card mt-3 pa-5">
            <h5 class="font-weight-bold mb-3">Monthly Shipment Volume </h5>
            <canvas id="barChart"></canvas>
        </v-card>

        <!-- Pie Chart 카드
        <v-card class="chart-card mt-3 pa-5">
            <h5 class="font-weight-bold mb-3">This Month Shipping Status</h5>
            <canvas id="pieChart"></canvas>
        </v-card> -->
      </div>
    </div>
  </template>
  
  <!-- <div class="jumbotron">
                    <h1 class="display-4">Welcome, {{ username }}!</h1>
                    <p class="lead">This is Offset management system.</p>
                    <hr class="my-4">
                    <p>It is prototype system for store parts to the Storage.
                    </p>
                    <p class="lead">
                        <button @click="logout" class="btn btn-primary btn-lg" role="button">Logout</button>
                    </p>
                </div> -->
<script>
// import axios from 'axios';
import Chart from 'chart.js/auto';
let barChartInstance = null; // 전역에 선언

export default {
    mounted() {
      this.getTotalCost(); // ✅ API 호출
        this.renderPieChart();
    },
    props: {
        username: String
    },
    components: {
    },
    data() {
        return {
            materialScanVisible: ['P0200', 'P0300', 'P1001', 'P1000', 'P2004'], // ✅ 신화, CNJ, 로지스올, 이화
            poNotVisible: ['P1001', 'P1000'],

            tab: null,
            dataLoaded: false,
            loading: false,
            partsList: [],
            statusList: [],
            requestStatus: 0,
            shippingStatus: 0,
            completeStatus: 0,
            cards: [
                { label: "Daily Demand", icon: "mdi-clock-outline", route: "/dailyDemand" },
                { label: "Order Status", icon: "mdi-clipboard-outline", route: "/orderStatus" },
                { label: "Invoice Issuance", icon: "mdi-clipboard-text-outline", route: "/invoiceIssuance" },
                { label: "Packing List History", icon: "mdi-archive-outline", route: "/packingHistory" },
                { label: "Supply Performance", icon: "mdi-clipboard-check-outline", route: "/supplyPerformance" },
            ],
            cards2: [
                { label: "Material Scan", icon: "mdi-barcode-scan", route: "/materialScan" },
                { label: "Scan History", icon: "mdi-history", route: "/scanHistory" },
              ]
        }
    },

    methods: {
      async getTotalCost() {
        this.loading = true;
        try {
          const response = await fetch(`/api/getTotalCost?username=${this.username}`);
          const result = await response.json();

          if (result.success) {
            // ✅ 받아온 데이터를 바 차트나 파이 차트에 넣으려면 다음과 같이 처리
            const monthlyData = result.data; // 예: [{ month: 'Jan', cost: 300 }, ...]
            const labels = monthlyData.map(item => item.month);
            const costs = monthlyData.map(item => item.totalCost);
            // Bar Chart 다시 렌더링
            this.renderBarChart(labels, costs);
            this.loading = false;
          } else {
            console.error("❌ 데이터 로드 실패:", result.message);
            this.loading = false;

          }
        } catch (err) {
          console.error("❌ getTotalCost 호출 중 오류:", err);
          this.loading = false;

        }
      },
      renderBarChart(labels, costs) {
        const ctx = document.getElementById('barChart').getContext('2d');

        // ✅ 12개월 기준값
        const allMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        // ✅ label에 없는 월은 0으로 채움
        const costMap = {};
        //console.log(labels)
        labels.forEach((label, index) => {
          costMap[label] = costs[index];
          //console.log(costMap[label])
        });
        const fullCosts = allMonths.map(month => Number(costMap[month]) || 0);
        //console.log(fullCosts)
        // ✅ 기존 차트 제거
        if (barChartInstance) {
          barChartInstance.destroy();
        }

        // ✅ 새 차트 생성
        barChartInstance = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: allMonths,
            datasets: [{
              label: 'Monthly Cost',
              data: fullCosts,
              backgroundColor: '#1976d2'
            }]
          },
          options: {
            responsive: true,
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    return `$${context.raw.toLocaleString()}`;
                  }
                }
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  callback: function (value) {
                    return `$${value.toLocaleString()}`;
                  }
                }
              }
            }
          }
        });
      },
        renderPieChart() {
            // const ctx = document.getElementById('pieChart').getContext('2d');
            // new Chart(ctx, {
            //     type: 'pie',
            //     data: {
            //     labels: ['Brake', 'Sensor', 'ECU', 'Motor'],
            //     datasets: [{
            //         label: 'Category Share',
            //         data: [30, 25, 20, 25],
            //         backgroundColor: ['#42a5f5', '#66bb6a', '#ffca28', '#ef5350']
            //     }]
            //     },
            //     options: {
            //     responsive: true
            //     }
            // });
        },
       
    }
};
</script>
<style scoped>
.custom-font {
    font-family: 'Noto Sans KR' !important;
}

.text-container {
    height: 80vh; /* 화면 높이의 50% 지점에 위치 */
    margin-left: 60vh;
    display: flex;
    justify-content: end; /* 가로 가운데 정렬 */
    align-items: center; /* 세로 가운데 정렬 */
}
.text-container2 {
    height: 1vh; /* 화면 높이의 50% 지점에 위치 */
    margin-left: 60vh;
    display: flex;
    justify-content: end; /* 가로 가운데 정렬 */
    align-items: center; /* 세로 가운데 정렬 */
}

/* 텍스트 스타일 */

@keyframes slideIn {
    from {
        opacity: 0; 
        transform: translateX(-50px); /* 왼쪽에서 시작 */
    }
    to {
        opacity: 1; 
        transform: translateX(0); /* 원래 위치로 */
    }
}

.card-equal  {
  width: 19%; /* 딱 5개가 한 줄에 맞게 */
  min-width: 200px;
  margin-right: 1%;
}

@media (max-width: 1200px) {
  .card-equal {
    width: 48%;
    margin-bottom: 20px;
  }
}

@media (max-width: 600px) {
  .card-equal {
    width: 100%;
    margin-bottom: 20px;
  }
}
.chart-card {
  width: 48%;
  min-width: 250px;
  margin-bottom: 20px;
  padding: 16px !important; /* 기본 pa-5에서 줄임 */
  font-size: 0.85rem; /* 전체적으로 폰트 축소 */
}

.chart-card h5 {
  font-size: 1rem;
  margin-bottom: 12px;
}

.chart-card canvas {
  max-height: 230px; /* 그래프 크기도 약간 줄임 */
}

/* 반응형 대응 */
@media (max-width: 992px) {
  .chart-card {
    width: 100%;
  }
}

.container-fluid {
  height : 95%;
  overflow-y: auto;
}
.btn-align {

  justify-content: center;
  align-items: center;

}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}
.loading-container {
  display: flex;
  align-items: center;
  gap: 15px; /* 스피너와 텍스트 간격 */
}

/* ✅ 빙글빙글 도는 스피너 */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 123, 255, 0.3);
  border-top: 5px solid #007bff;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

/* ✅ 스피너 애니메이션 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* ✅ 출렁이는 색상 변화 효과 */
.loading-text {
  font-size: 64px;
  font-weight: bold;
  text-transform: uppercase;
  background: linear-gradient(120deg, #ffffff, #007bff, #ffffff);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  color: transparent;
  animation: waveColor 3s ease-in-out infinite;
}

/* ✅ 출렁이는 애니메이션 */
@keyframes waveColor {
  0% {
    background-position: 0% 70%;
  }
  50% {
    background-position: 100% 30%;
  }
  100% {
    background-position: 0% 70%;
  }
}

.material-card {
  width: 19%;  /* 두 개가 한 줄에 딱 맞도록 */
  min-width: 220px;
  margin-right: 1%;
}

@media (max-width: 768px) {
  .material-card {
    width: 100%;
  }
}

</style>